/**
 * Alpine.js component registrations.
 * Uses Livewire 3's bundled Alpine instance (via alpine:init event).
 * Do NOT import alpine.min.js separately — Livewire ships it.
 */
document.addEventListener('alpine:init', () => {

    Alpine.data('appData', () => {

        function getDark() {
            if (window.localStorage.getItem('dark')) {
                return JSON.parse(window.localStorage.getItem('dark'));
            }
            return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
        }

        function getSidebarCollapsed() {
            if (window.localStorage.getItem('sidebarCollapsed')) {
                return JSON.parse(window.localStorage.getItem('sidebarCollapsed'));
            }
            return false;
        }

        return {
            dark: getDark(),
            sidebarCollapsed: getSidebarCollapsed(),

            toggleTheme() {
                this.dark = !this.dark;
                window.localStorage.setItem('dark', this.dark);
                document.documentElement.classList.toggle('dark', this.dark);
            },

            toggleSidebar() {
                this.sidebarCollapsed = !this.sidebarCollapsed;
                window.localStorage.setItem('sidebarCollapsed', this.sidebarCollapsed);
            },

            isSideMenuOpen: false,
            toggleSideMenu() { this.isSideMenuOpen = !this.isSideMenuOpen; },
            closeSideMenu()  { this.isSideMenuOpen = false; },

            isUserMenuOpen: false,
            toggleProfileMenu() { this.isUserMenuOpen = !this.isUserMenuOpen; },
            closeProfileMenu()  { this.isUserMenuOpen = false; },

            isModalOpen: false,
            openModal()  { this.isModalOpen = true; },
            closeModal() { this.isModalOpen = false; },

            init() {
                // Apply persisted dark mode on first render
                document.documentElement.classList.toggle('dark', this.dark);
            },
        };
    });

});
